import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCollectionKey, getCollectionsKey } from '../../utils/keys';
export const useUpdateCollection = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.collections.update(input), {
        onSettled: (data, error, variables) => {
            const collectionKey = getCollectionKey({
                variables: { id: variables.id },
            });
            queryClient.invalidateQueries(collectionKey);
            const collectionsKey = getCollectionsKey();
            queryClient.invalidateQueries(collectionsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateCollection.js.map